import isFreeEcommercePlanType from './is-free-ecommerce-plan-type';
import isFreeHostingPackageType from './is-free-hosting-package-type';
import hasExpiredPaidSubscription from './has-expired-paid-subscription';
import hasTrialSubscription from './has-trial-subscription';
import hasActiveTrialSubscription from './has-active-trial-subscription';
import hasRenewablePaidSubscription from './has-renewable-paid-subscription';
import hasPaidHostingPackageType from './has-paid-hosting-package-type';
import hasAnnualPaidHostingSubscription from './has-annual-paid-hosting-subscription';
import isDomainPackageType from './is-domain-package-type';
import isPaidHostingPackageType from './is-paid-hosting-package-type';
import isHostingPackageType from './is-hosting-package-type';
import isPlanAvailable from './is-plan-available';
import isEcommercePlanType from './is-ecommerce-plan-type';
import isTrialSubscription from './is-trial-subscription';
import isActiveTrialSubscription from './is-active-trial-subscription';

export default {
  isFreeEcommercePlanType,
  isFreeHostingPackageType,
  hasExpiredPaidSubscription,
  hasRenewablePaidSubscription,
  hasPaidHostingPackageType,
  hasActiveTrialSubscription,
  hasTrialSubscription,
  hasAnnualPaidHostingSubscription,
  isDomainPackageType,
  isPaidHostingPackageType,
  isHostingPackageType,
  isPlanAvailable,
  isEcommercePlanType,
  isTrialSubscription,
  isActiveTrialSubscription,
};
